<template>
	<div class="list-group no-border border-radius-2 mb-3">
		<div class="list-group-item list-group-item-secondary" @click="selectItem()">
			<strong>{{$datetime.getLocaleDateStringFromTimestamp(placement.from, isUTC=true)}}
			{{$datetime.getLocaleTimeStringFromTimestamp(placement.from, isUTC=true)}} -
			{{$datetime.getLocaleTimeStringFromTimestamp(placement.to, isUTC=true)}} | {{placement.ttroom.name}}</strong>
		</div>
		<div class="list-group-item clearfix">
			<template v-if="placement.students.length==1">
				{{$t('{n}-student' , {n: placement.students.length})}}
			</template>
			<template v-else>
				{{$t('{n}-students' , {n: placement.students.length})}}
			</template>
		</div>
		<template v-if="selected">
			<div
				class="list-group-item"
				v-for="(student, index) in placement.students"
				v-bind:key="`${placement.id}_${index}`"
			>
				<Avatar
					class="avatar float-left mr-4 mb-0 lg:mb-0"
					:userId="student.id"
				/>
				<div class="mr-4 mb-0">
					<h3 class="mb-0">
						{{student.displayname}}
					</h3>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import Avatar from "../Avatar.vue";
export default {
	components: {
		Avatar
	},
    props: {
        placement: Object
    },
    data() {
    	return {
    		selected: false
    	}
    },
	mounted() {
	},
	methods: {
		selectItem: function(){
			this.selected = !this.selected;
		}
	}
};
</script>
